import { TApplicationState } from '../../types/redux';

export function getHousesCount(state: TApplicationState) {
  const {
    newbuilding: { housesCount },
  } = state;

  return housesCount;
}
